module.exports = __webpack_public_path__ + "static/media/f-1-07.a27db3cd.svg";